import { h, ComponentChildren, FunctionComponent, toChildArray } from "preact"; /** @jsx h */

import { clsx } from 'clsx';
import { Main, type IMainProps } from './Main';
import { Social, ISocialProps } from './Social';
import { Subscribe } from "../Subscribe";

export type ISectionProps = {
	// see: https://stackoverflow.com/questions/66597639/preact-typescript-only-allow-a-specific-component-as-children
    children?: ComponentChildren;
    weight?: 'full' | 'normal';
};

export const Content = (props: ISectionProps) => {
    
	return (
        
        <div className="container pt-4 pb-4">
            <div className="row justify-content-center">
                {/*<Social />*/}
                
                <div className={clsx("col-md-12", props.weight !== 'full' && "col-lg-8")}>
                    <article className="article-post">
                    {
                        props.children
                    } 
                    </article>
                    {/**<Subscribe />*/}
                </div>
            </div>
        </div>
        
		
	);
}

